<template>
<div>
  <div class="splash" v-if="!preloadDone">
    <div class="container  d-flex h-100">
      <div class="row justify-content-center text-primary w-100 align-self-center text-white">
        <i class="fa fa-spin fa-spinner"></i>
      </div>
    </div>
  </div>
  <div v-if="preloadDone">
    <b-card class="mt-1" header="Stocks">
      <div v-if="!showResults">

        <div class="row">
          <div class="col-md-3">
            <b-form-group label="Mostrar em linha">
              <b-form-radio-group id="btnradios2" button-variant="outline-primary" buttons size="sm" v-model="readOptions.rows" :options="rows" name="radiosRows" />
            </b-form-group>
          </div>
        </div>
        <div>
          <b-button variant="success" :disabled="loadingResults" class="btn-block" size="lg" v-on:click="showData()"><i v-bind:class="{'fa-search': !loadingResults, 'fa-spinner': loadingResults, 'fa-spin': loadingResults}" class="fa fa-search"></i> Pesquisar</b-button>
        </div>
        <b-alert class="mt-3" variant="danger" :show="queryErrorShow" dismissible>
          <h4 class="alert-heading">Erro</h4> Houve um erro com a sua pesquisa
        </b-alert>
      </div>
      <div v-if="showResults">
        <div class="row">
          <div class="col-sm-9">
            a mostrar em linhas: <strong>{{ rowsText }}</strong>
          </div>
          <div class="col-sm-3">
            <b-button class="pull-right btn-block" variant="warning" size="lg" v-on:click="showForm()">Alterar</b-button>
          </div>
        </div>
      </div>
    </b-card>
    <fullscreen :fullscreen.sync="fullscreenGrid">
      <div id="stocks-results" class="stocks-results" v-if="showResults">
        <b-card no-body>
          <b-card-header class="text-right">
            <a href="#" v-if="$auth.check(['all.export', 'stocks.export'])" @click="exportResults"><i class="fa fa-download"></i> exportar</a> |
            <a href="#" @click="toggleFullscreen"><i class="fa fa-expand"></i> fullscreen</a>
          </b-card-header>
          <generic-grid :rows="rows" :groupDefinition="groupDefinition" :aggregateDefinition="aggregateDefinition" ref="stocksGrid" v-bind:query="readOptions" v-if="loaded" name="stocksGrid" v-bind:url="url" detail-url="stocks" v-bind:columns="columns" :pageable='true'
            :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields" v-bind:schemaModelId="'id'" v-bind:preload="preload" :details="details" v-on:ds-error="loadingError"></generic-grid>
        </b-card>
      </div>
    </fullscreen>
  </div>
  <filters id="filters-grid" ref="filtersPane" :filters="filterOptions" :showFilterGrid="showFilterGrid" :showResults="showResults" :totalFilters="totalFilters" :readOptions="readOptions"></filters>
  <b-modal ref="downloadModal" id="downloadModal">
    O ficheiro está pronto:
    <a :href="fileDownload.url" target="_blank">{{ fileDownload.title }}</a>
    <div slot="modal-footer" class="w-100">
      <b-btn size="sm" class="float-right" variant="primary" @click="hideModal">
        Close
      </b-btn>
    </div>
  </b-modal>
  <b-modal ref="downloadModal" id="downloadModal">
    O ficheiro está pronto:
    <a :href="fileDownload.url" target="_blank">{{ fileDownload.title }}</a>
    <div slot="modal-footer" class="w-100">
      <b-btn size="sm" class="float-right" variant="primary" @click="hideModal">
        Close
      </b-btn>
    </div>
  </b-modal>
  <b-modal ref="saveModal" id="saveModal" title="Gravar pesquisa">
    <b-form @submit="saveQuery">
      <b-form-input v-model="queryName" ref="queryName" type="text"></b-form-input>
    </b-form>
    <div slot="modal-footer" class="w-100">
      <b-btn size="sm" class="float-left" variant="secondary" @click="hideSaveModal">
        Close
      </b-btn>
      <b-btn size="sm" class="float-right" variant="success" @click="saveQuery">
        <i class="fa fa-save-o"></i> Gravar
      </b-btn>
    </div>
  </b-modal>
  <b-modal ref="shareModal" id="shareModal">
    <b-form>
      <b-form-input v-model="queryUrl" readonly ref="queryName" type="text"></b-form-input>
    </b-form>
    <div slot="modal-footer" class="w-100">
      <b-btn size="sm" class="float-left" variant="secondary" @click="hideShareModal">
        Close
      </b-btn>
    </div>
  </b-modal>
  <b-modal @shown="showQueries=true" @hidden="showQueries=false" size="lg" ref="loadQueryModal" id="loadQueryModal">
    <UserQueries v-if="showQueries" height="400" v-on:load-query="loadUserQuery" />
  </b-modal>
</div>
</template>
<script>
import Vue from 'vue'
import Filters from '@/views/stocks/Filters.vue'
import UserQueries from '@/views/Statistics/UserQueries.vue'
import fullscreen from 'vue-fullscreen'

// import kendo from '@progress/kendo-ui/js/kendo.all.js'
import {
  PopupsInstaller
} from '@progress/kendo-popups-vue-wrapper'

Vue.use(PopupsInstaller)
Vue.use(fullscreen)
export default {
  name: 'Stocks',
  components: {
    Filters,
    UserQueries
  },
  data() {
    return {
      preload: [],
      schemaModelFields: {},
      url: 'stocks',
      loadingResults: false,
      queryErrorShow: false,
      readOptions: {
        columns: 'gsv',
        rows: 'mpg_id',
        groupby: 'none',
        presetdate: 'all',
        datetype: 'y',
        clientType: 'A',
        docType: 'AGR',
        year: 2026,
        dates: {
          start: {
            day: 1,
            month: 1,
            year: 2026
          },
          end: {
            day: 31,
            month: 12,
            year: 2026
          }
        },
        filters: []
      },
      clientTypes: [{
        value: 'A',
        text: 'Todos'
      }, {
        value: 'F',
        text: 'Fatura'
      }, {
        value: 'G',
        text: 'Guias'
      }],
      documentTypes: [{
        value: 'A',
        text: 'Todos'
      }, {
        value: 'AGR',
        text: 'Sem guias'
      }],
      aggregateDefinition: [],
      details: [],
      columns: [],
      preloadDone: false,
      loaded: false,
      showFilterType: '',
      showFilterGrid: true,
      showResults: false,
      tableInitialized: false,
      fullscreenGrid: false,
      exporting: false,
      showQueries: false,
      fileDownload: '',
      variables: [],
      rows: [],
      subrows: [],
      groups: [],
      queryName: '',
      queryUrl: '',
      years: [{
        value: 2022,
        text: '2022'
      }, {
        value: 2023,
        text: '2023'
      }, {
        value: 2024,
        text: '2024'
      }, {
        value: 2025,
        text: '2025'
      }, {
        value: 2026,
        text: '2026'
      }],
      days: [],
      months: [{
        value: 1,
        text: 'Jan.'
      }, {
        value: 2,
        text: 'Fev.'
      }, {
        value: 3,
        text: 'Mar.'
      }, {
        value: 4,
        text: 'Abr.'
      }, {
        value: 5,
        text: 'Mai.'
      }, {
        value: 6,
        text: 'Jun.'
      }, {
        value: 7,
        text: 'Jul.'
      }, {
        value: 8,
        text: 'Ago.'
      }, {
        value: 9,
        text: 'Set.'
      }, {
        value: 10,
        text: 'Out.'
      }, {
        value: 11,
        text: 'Nov.'
      }, {
        value: 12,
        text: 'Dez.'
      }],
      filterOptions: [{
        text: 'Gama',
        value: 'mpg_id'
      }, {
        text: 'Prodaggreg',
        value: 'product_aggregator_id'
      }],
      datesOptions: [{
        text: 'todos',
        value: 'all'
      }, {
        text: 'Q1',
        value: 'q1'
      }, {
        text: '30 dias',
        value: '30'
      }, {
        text: '60 dias',
        value: '60'
      }, {
        text: '90 dias',
        value: '90'
      }, {
        text: 'customizado',
        value: 'custom'
      }],
      periodType: [{
        value: 'y',
        text: 'Ano'
      }, {
        value: 'ym',
        text: 'Ano / Mês'
      }]
    }
  },
  watch: {
    'readOptions.rows': function(val, oldVal) {
      this.changedRows()
    }
  },
  methods: {
    showData() {
      this.loaded = false
      this.loadingResults = true
      this.queryErrorShow = false
      this.showFilterGrid = false
      this.showResults = false
      this.axios.post('stocks/columns', this.readOptions).then(response => {
        this.columns = response.data.data.columns
        this.aggregateDefinition = response.data.data.aggregates
        this.groupDefinition = response.data.data.groups
        this.schemaModelFields = response.data.data.fields

        if (!this.tableInitialized) {
          this.loaded = true
          this.showResults = true
        } else {
          this.$refs.statsGrid.refresh()
          this.showResults = true
          this.loaded = true
        }
        var that = this
        setTimeout(function() {
          that.$scrollTo('#stocks-results', 300, {
            offset: -60
          })
        }, 100)
      })
    },
    showForm() {
      this.loaded = false
      this.showResults = false
      this.showFilterGrid = true
      this.loadingResults = false
    },
    loadingError(e) {
      this.loaded = false
      this.loadingResults = false
      this.showFilterGrid = true
      this.showResults = false
      this.queryErrorShow = true
    },
    changedRows() {
      this.details = this.rows[this.readOptions.rows].details
    },
    exportResults(e) {
      e.preventDefault()
      this.exporting = true
      this.axios.post('stocks/export', this.readOptions).then(response => {
        this.fileDownload = response.data
        this.$refs.downloadModal.show()
        this.exporting = false
      })
    },
    toggleFullscreen() {
      this.fullscreenGrid = !this.fullscreenGrid
    },
    hideModal: function() {
      this.$refs.downloadModal.hide()
    },
    hideSaveModal: function() {
      this.$refs.saveModal.hide()
    },
    hideShareModal: function() {
      this.$refs.shareModal.hide()
    },
    getTooltipContents: function(e) {
      return e.target.data('past') + '<br>' + e.target.data('current') + '<br>' + e.target.data('dif')
    },
    getQuery(queryId) {
      this.axios.get('queries/' + queryId).then(response => {
        this.loadQuery(response.data.data)
      })
    },
    openSaveQueryPopup() {
      this.$refs.saveModal.show()
    },
    openLoadQueryPopup() {
      this.$refs.loadQueryModal.show()
    },
    shareQuery() {
      this.axios.post('queries', this.readOptions).then(response => {
        var route = this.$router.resolve({
          name: 'stocks.index',
          params: {
            id: response.data.data.uuid
          }
        })
        this.queryUrl = window.location.origin + route.href
        this.$refs.shareModal.show()
      })
    },
    saveQuery() {
      this.axios.post('userqueries', {
        query: this.readOptions,
        name: this.queryName
      }).then(response => {
        this.$router.replace({
          name: 'stocks.index',
          params: {
            id: response.data.data.uuid
          }
        })
        this.hideSaveModal()
      })
    },
    loadUserQuery(evt) {
      this.$router.push({
        name: 'stocks.index',
        params: {
          id: (evt.item.uquery.data.uuid)
        }
      })
      // this.loadQuery(evt.item.uquery.uuid)
      this.$refs.loadQueryModal.hide()
    },
    loadQuery(data) {
      this.readOptions.presetdate = data.presetdate
      this.readOptions.datetype = data.datetype
      this.readOptions.dates = data.dates
      this.readOptions.year = data.year
      this.readOptions.rows = data.rows
      this.readOptions.subrows = data.subrows
      this.readOptions.groupby = data.groupby
      this.readOptions.filters = data.filters
    }
  },
  computed: {
    rowsText() {
      return this.rows[this.readOptions.rows].text
    },
    totalFilters() {
      var total = 0
      for (var i = 0; i < this.readOptions.filters.length; i++) {
        total += this.readOptions.filters[i].includes.length
        total += this.readOptions.filters[i].excludes.length
      }
      return total
    }
  },
  beforeRouteUpdate(to, from, next) {
    // react to route changes...
    // don't forget to call next()
    if (to.params.id !== 'index') {
      this.axios.get('queries/' + to.params.id).then(response => {
        this.loadQuery(response.data.data)
        next()
      })
    } else {
      this.readOptions = {
        columns: 'gsv',
        rows: 'client_id',
        groupby: 'none',
        presetdate: 'all',
        datetype: 'y',
        clientType: 'A',
        docType: 'AGR',
        year: 2018,
        dates: {
          start: {
            day: 1,
            month: 1
          },
          end: {
            day: 31,
            month: 12
          }
        },
        filters: []
      }
      next()
    }
  },
  created() {
    for (var i = 1; i <= 31; i++) {
      this.days.push({
        value: i,
        text: i
      })
    }
    var apiPreloads = [{
      url: 'stocks/rows',
      callback: setRows
    }]
    if (typeof this.$route.params.id !== 'undefined' && this.$route.params.id !== 'index') {
      apiPreloads.push({
        url: 'queries/' + this.$route.params.id,
        callback: this.loadQuery
      })
    }
    var that = this
    this.axios.all(apiPreloads.map(l => this.axios.get(l.url))).then(
      that.axios.spread(function() {
        for (var i = 0; i < apiPreloads.length; i++) {
          apiPreloads[i].callback(arguments[i].data.data)
        }
        that.preloadDone = true
      })
    ).catch(response => {
      console.error('error loading foreigns', response)
    })

    function setRows(response) {
      that.rows = response
      that.details = that.rows[that.readOptions.rows].details
    }
  }
}
</script>



// WEBPACK FOOTER //
// Stocks.vue?5d54e81c